import React from 'react';
import './ModemDetails.css';
import '../../i18n';
import { useTranslation } from 'react-i18next';

import Battery from "../../assets/images/battery.png"

const Battery_SPEC = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="spec-container">
      <div className="spec-header-image">
        <img src={Battery} className="spec-header-image-img" />
      </div>

      <div className="spec-item full-width">
        <h2 className="spec-title">{t('accessoires.battery.details.title')}</h2>
        <ul className="spec-details">
          <li>{t('accessoires.battery.details.common.p1')}</li>
          <li>{t('accessoires.battery.details.common.p2')}</li>
          <li>{t('accessoires.battery.details.common.p3')}</li>
          <li>{t('accessoires.battery.details.common.p4')}</li>
        </ul>
      </div>      

    </div>
  );
};

export default Battery_SPEC;
